import service from '@/utils/axios';

// 产品栏目
export function getContent(id) {
    return service({
        url: '/admin/api/v1/dxsf/official/class/getContent',
        params: {id}
    })
}


// WEBPACK FOOTER //
// ./src/api/other.js